import React, { createContext, Dispatch, ReactNode, SetStateAction, useState } from 'react';
import { SortingRule } from 'react-table';

interface TableState {
  state: {
    sortBy: SortingRule<string>[];
  };
}

interface ReactTableContext extends TableState {
  handlers: {
    setSortBy: Dispatch<SetStateAction<SortingRule<string>[]>> | (() => void);
  };
}

const initialContext: ReactTableContext = {
  state: {
    sortBy: [{ id: '', desc: false }]
  },
  handlers: {
    setSortBy: () => undefined
  }
};

export const ReactTableContext = createContext<ReactTableContext>(initialContext);

export const ReactTableContextProvider = ({
  children,
  initialState
}: {
  children: ReactNode;
  initialState?: TableState;
}) => {
  const [sortBy, setSortBy] = useState<SortingRule<string>[]>(
    initialState?.state.sortBy || initialContext.state.sortBy
  );
  return (
    <ReactTableContext.Provider
      value={{
        state: {
          sortBy
        },
        handlers: {
          setSortBy
        }
      }}
    >
      {children}
    </ReactTableContext.Provider>
  );
};
